__turbopack_context__.v({
  "banner": "FlightCancellationOfferBanner-module__9j2DkW__banner",
  "conditions": "FlightCancellationOfferBanner-module__9j2DkW__conditions",
  "ctaCol": "FlightCancellationOfferBanner-module__9j2DkW__ctaCol",
  "desktop": "FlightCancellationOfferBanner-module__9j2DkW__desktop",
  "forceMobile": "FlightCancellationOfferBanner-module__9j2DkW__forceMobile",
  "icon": "FlightCancellationOfferBanner-module__9j2DkW__icon",
  "knowMoreCta": "FlightCancellationOfferBanner-module__9j2DkW__knowMoreCta",
  "mobile": "FlightCancellationOfferBanner-module__9j2DkW__mobile",
  "pillar": "FlightCancellationOfferBanner-module__9j2DkW__pillar",
  "text": "FlightCancellationOfferBanner-module__9j2DkW__text",
  "title": "FlightCancellationOfferBanner-module__9j2DkW__title",
});
